<template>
  <div id="app">
    <div id="craftie_play" style="width: 100%; height: 600px"></div>
  </div>
</template>
<script>
export default {
  name: "CraftiePlay",
  components: {},
  data() {
    return {};
  },
  methods: {
    getData() {
      this.$api.rootV1.post(
        "/web/statistics/craftieplaycount",
        {
          start: Date.parse(new Date()) - 7776000 + "",
          end: Date.parse(new Date()) + "",
        },
        (res) => {
          if (res.errcode == 0) {
            let data = res.data;
            //let data=[{"date": "2020-10-14 15","totalCount": "1"},{"date": "2020-10-15 15","totalCount": "2"},]
            let dates = [],
              totalCounts = [];
            for (let item of data) {
              dates.push(item.crafite_name);
              totalCounts.push(item.totalCount);
            }
            this.drawChart(dates, totalCounts);
          }
        }
      );
    },
    drawChart(dates, totalCounts) {
      var echarts = require("echarts");
      // 基于准备好的dom，初始化echarts实例
      let myChart = echarts.init(document.getElementById("craftie_play"));
      // 指定图表的配置项和数据
      let option = {
        color: ["#3398DB"],
        title: { text: "Craftie statistical", left: "center" },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            // 坐标轴指示器，坐标轴触发有效
            type: "shadow", // 默认为直线，可选为：'line' | 'shadow'
          },
        },
        grid: {
          left: "3%",
          right: "4%",
          bottom: "3%",
          containLabel: true,
        },
        yAxis: {
          type: "category",
          //data: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'],
          data: dates,
          axisTick: {
            alignWithLabel: true,
          },
        },
        xAxis: { type: "value"},
        series: [
          {
            name: "count",
            type: "bar",
            //data: [10, 52, 200, 334, 390, 330, 220]
            data: totalCounts,
          },
        ],
      };
      // 使用刚指定的配置项和数据显示图表。
      myChart.setOption(option);
    },
  },
  mounted() {
    this.getData();
  },
};
</script>


// WEBPACK FOOTER //
// src/components/main/statistics/CraftiePlay.vue